module.exports = __webpack_public_path__ + "static/media/Vanuatu - VU.a67925ef.png";